import { useParams, useNavigate } from 'react-router-dom';

import { BasicDrawer } from '@/components/ui/basic-drawer';
import { CaseForm } from '@/components/cases/case-form';

export function CaseEditPage() {
  const { caseId } = useParams<{ caseId: string }>();
  const navigate = useNavigate();

  const handleContinueToImageUpload = (currentCaseId: string) => {
    navigate(`/cases/process-case/${currentCaseId}`, { replace: true });
  };

  const onClose = () => {
    navigate(-1);
  };

  return (
    <BasicDrawer open={true} onClose={onClose}>
      <CaseForm setNewCaseId={handleContinueToImageUpload} caseId={caseId} />
    </BasicDrawer>
  );
}
